import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteAPromotional,
  getPromotionals,
  resetState,
} from "../features/promotype/promotypeSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },

  {
    title: "Action",
    dataIndex: "action",
  },
];

const Promolist = () => {
  const [open, setOpen] = useState(false);
  const [promotionalId, setpromotionalId] = useState("");
  const [loading, setLoading] = useState(true);

  const showModal = (e) => {
    setOpen(true);
    setpromotionalId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(resetState());
      await dispatch(getPromotionals());
      setLoading(false);
    };

    fetchData();
  }, [dispatch]);

  const promoStat = useSelector((state) => state.promoType.promoLists);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const data1 = promoStat.map((promo, index) => ({
    key: index + 1,
    name: promo.promotype_name,
    action: (
        <>
          <Link
            to={`/admin/Promotional/${promo._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(promo._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    }));

  const deletePromotionalType = (e) => {
    dispatch(deleteAPromotional(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getPromotionals());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Promotional Type</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deletePromotionalType(promotionalId);
        }}
        title="Are you sure you want to delete this Product Category?"
      />
    </div>
  );
};

export default Promolist;
